import axios from 'axios';

let installed = false;

export const installAdminAuthInterceptor = () => {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const isAdminRoute = window.location.pathname.startsWith('/admin');
      if ((status === 401 || status === 403) && isAdminRoute && localStorage.getItem('token')) {
        localStorage.clear();
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
};
